import React from 'react';
import BaseModel from '../../BaseModal'
import styled from 'styled-components';
import { LineView } from '../../styles/WrapperStyles';

const ParentDiv = styled.div`
  width: 445px;
  height: 239px;
  border-radius: 20px;
`;

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
  cursor: pointer;
`;

const SortByModal = (props) => {
    return (
        <BaseModel closeModal={() => props.closeModal()}>
            <ParentDiv>
                <div onClick={() => props.updateOption('most_reported')}>
                    <TextView>Most Reported</TextView>
                    <LineView />
                </div>
                <div onClick={() => props.updateOption('most_recently')}>
                    <TextView>Most Recently</TextView>
                    <LineView />
                </div>
            </ParentDiv>
        </BaseModel>
    );
};

export default SortByModal;
